import { FC, useState } from 'react'

import MTravelLogo from 'shared/icons/mtravel_icon_text.svg'

interface Props {
  className?: string
  src?: string
  alt?: string
  errorImage?: string
}

// TODO: Использовать ImageOptimized вместо ImageLazy
export const ImageLazy: FC<Props> = ({ className, src, alt, errorImage }) => {
  const [error, setError] = useState<boolean>(false)

  return (
    <>
      {error ? (
        <img
          src={errorImage || MTravelLogo}
          className={className}
        />
      ) : (
        <img
          src={src || ''}
          loading="lazy"
          alt={alt || ''}
          className={className}
          onError={() => setError(true)}
        />
      )}
    </>
  )
}
